<template>
<div>
  <v-toolbar dense :extended='!isBasePage' >
    <v-toolbar-title >
      {{ $route.name }}
    </v-toolbar-title>
    <template v-if='!isBasePage' slot='extension' >
      <v-btn to='/integrations/' small flat text class='pl-0' >Integrations</v-btn>
      <v-icon >chevron_right</v-icon>
      {{ $route.name }}
    </template>
    <v-spacer></v-spacer>
    <v-btn small outline target='_blank' color="info"
      v-if='$route.meta.installHelp'
      :href='$route.meta.installHelp' >
      <v-icon small class="mr-1" >info</v-icon>
      Help <v-icon small small class="ml-1">open_in_new</v-icon>
    </v-btn>
  </v-toolbar>
  <router-view ></router-view>
</div>
</template>

<script>
export default {
  name: 'Integrations',
  computed: {
    isBasePage () {
      return this.$route.name === 'Integrations'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// index.vue?88aa746c